import { render, staticRenderFns } from "./segmentConfigList.vue?vue&type=template&id=acb318ce&scoped=true&"
import script from "./segmentConfigList.vue?vue&type=script&lang=js&"
export * from "./segmentConfigList.vue?vue&type=script&lang=js&"
import style0 from "./segmentConfigList.vue?vue&type=style&index=0&id=acb318ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb318ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VList,VListItemContent,VListItemSubtitle,VTooltip})
